import { render, staticRenderFns } from "./p-spinner.vue?vue&type=template&id=411df358&"
import script from "./p-spinner.vue?vue&type=script&lang=js&"
export * from "./p-spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports